<template>
  <div>
    <v-dialog
      v-model="dialogDetail"
      persistent
      max-width="600px"
      class="container1"
      scrollable
      :key="keyComponent"
    >
      <v-card :height="innerHeight" class="overflow-auto">
        <div class="d-flex justify-center pa-2" style="position: relative">
          <div style="max-height: 240px">
            <img
              :src="item.image_url || item.image_path"
              style="
                max-width: 100%;
                max-height: 240px;
                width: auto;
                height: auto;
                border-radius: 10px;
                object-fit: contain;
                display: block;
                margin: 0 auto;
              "
            />
          </div>

          <v-btn
            fab
            x-small
            style="z-index: 9999; position: absolute; top: 8px; right: 8px"
            class="ma-1 close-button"
            @click="$emit('close')"
            ><v-icon small :color="site.color">mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-title>
          <v-row>
            <v-col cols="9" class="py-0 align-center">
              <p class="text-subtitle-1 mb-0 truncate-text">
                {{ item.name }}
              </p>
            </v-col>
          </v-row>
        </v-card-title>

        <v-divider style="opacity: 1; color: black" class="ma-3"></v-divider>
        <v-card-text class="pb-2 pt-2">
          <v-row v-if="!hidePointBox || !hideAmountBox" class="pb-2">
            <v-col cols="6" class="pa-0">
              <v-list-item v-if="!hidePointBox" class="pa-0">
                <v-list-item-avatar size="30" class="ml-3 mr-3">
                  <PointSymbol
                    v-if="Array.isArray(item.point) && item.point.length > 0"
                    :type="item.point[0].point_type_type"
                    :symbol="item.point[0].point_type_symbol"
                    :color="item.point[0].point_type_color"
                    :is_display="true"
                    :outlined_box="false"
                    :size="30"
                  />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title style="font-size: 10px">{{
                    $t("coinCost")
                  }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <div
                      v-if="
                        Array.isArray(item.point_used) &&
                        item.point_used.length > 0
                      "
                      class="text-truncate"
                      style="width: 100%"
                    >
                      {{ item.point_used[0].point | commaPoint }}
                      {{ item.point_used[0].point_type_name }}
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="6" class="pa-0">
              <v-list-item v-if="!hideAmountBox" class="pa-0">
                <v-list-item-avatar size="30" class="ml-3 mr-3">
                  <v-img src="@/assets/images/package.png"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title style="font-size: 10px">{{
                    $t("availableStock")
                  }}</v-list-item-title>
                  <v-list-item-subtitle>{{
                    item.number_of_items | commaPoint
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>

          <div v-if="item.period">
            <p class="text-subtitle-2 mb-0 font-weight-bold mt-2 black--text">
              {{ $t("duration") }}
            </p>
            <div class="d-flex mb-4">
              <v-icon class="mr-1" size="16" color="grey"
                >mdi-calendar-blank-outline</v-icon
              >
              <p class="pa-0 ma-0">{{ item.period }}</p>
            </div>
          </div>

          <div v-if="item.location">
            <p class="text-subtitle-2 mb-0 font-weight-bold black--text">
              {{ $t("location") }}
            </p>
            <div class="d-flex mb-4">
              <v-icon class="mr-1" size="16" color="grey"
                >mdi-map-marker</v-icon
              >
              <p class="pa-0 ma-0">{{ item.location }}</p>
            </div>
          </div>

          <div v-if="item.description">
            <p class="text-subtitle-2 mb-0 font-weight-bold black--text">
              {{ $t("detail") }}
            </p>
            <p>{{ item.description }}</p>
          </div>

          <div v-if="item.term_and_condition">
            <p class="text-subtitle-2 mb-0 font-weight-bold black--text">
              {{ $t("termAndCondition2") }}
            </p>
            <p>{{ item.term_and_condition }}</p>
          </div>

          <div v-if="item.code" class="w-100 d-flex align-center flex-column">
            <div class="d-flex mb-4" style="gap: 8px">
              <v-chip
                dark
                :color="site.color"
                :outlined="codeType != 'qrcode'"
                :style="{
                  color: codeType == 'qrcode' ? '#FFFFFF' : site.color,
                  fontWeight: 600,
                  cursor: 'pointer',
                }"
                @click="handleChangeCodeType('qrcode')"
                >{{ $t("qrCode") }}</v-chip
              >
              <v-chip
                dark
                :color="site.color"
                :outlined="codeType != 'barcode'"
                :style="{
                  color: codeType == 'barcode' ? '#FFFFFF' : site.color,
                  fontWeight: 600,
                  cursor: 'pointer',
                }"
                @click="handleChangeCodeType('barcode')"
                >{{ $t("barCode") }}</v-chip
              >
              <v-chip
                dark
                :color="site.color"
                :outlined="codeType != 'code'"
                :style="{
                  color: codeType == 'code' ? '#FFFFFF' : site.color,
                  fontWeight: 600,
                  cursor: 'pointer',
                }"
                @click="handleChangeCodeType('code')"
                >{{ $t("code") }}</v-chip
              >
            </div>
            <div
              class="w-100 d-flex justify-center align-center flex-column"
              style="height: 240px"
            >
              <div v-if="codeType == 'qrcode'">
                <qrcode-vue
                  class="mb-2"
                  :value="item.code"
                  :size="200"
                  level="H"
                ></qrcode-vue>
              </div>
              <div v-if="codeType == 'barcode'">
                <VueBarcode v-bind:value="item.code"> </VueBarcode>
              </div>
              <div v-if="codeType == 'code'">
                <div
                  class="d-flex pa-4"
                  style="
                    border-radius: 8px;
                    border-style: solid;
                    border-width: 1px;
                  "
                  :style="{
                    borderColor: site.color,
                  }"
                  @click="handleCopyCode"
                >
                  <v-btn icon @click="handleCopyCode"
                    ><v-icon :color="site.color"
                      >mdi-content-copy</v-icon
                    ></v-btn
                  >
                  <p
                    class="ma-0 ml-1"
                    style="line-height: 1"
                    :style="{
                      color: site.color,
                      fontSize: '2rem',
                    }"
                  >
                    {{ item.code }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions v-if="!hideSubmit" class="d-block">
          <v-list-item class="grow" style="display: -webkit-box">
            <v-row align="start" justify="space-between">
              <v-col cols="12" class="px-0">
                <v-btn
                  :color="site.color"
                  class="rounded-lg white--text text-capitalize"
                  @click="$emit('redeemReward', quantity)"
                  width="100%"
                >
                  {{ $t("redeemPoint") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-list-item>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import VueBarcode from "vue-barcode";
import PointSymbol from "../point/point-symbol.vue";

export default {
  props: [
    "item",
    "dialogDetail",
    "keyComponent",
    "site",
    "hidePointBox",
    "hideAmountBox",
    "hideSubmit",
  ],
  components: {
    QrcodeVue,
    VueBarcode,
    PointSymbol,
  },
  data() {
    return {
      quantity: 1,
      codeType: "qrcode",
    };
  },
  created() {},
  methods: {
    handleChangeCodeType(param) {
      this.codeType = param;
    },
    handleCopyCode() {
      navigator.clipboard.writeText(this.item.code);
    },
  },
  watch: {
    dialogDetail(value) {
      if (value) {
        this.quantity = 1;
      }
    },
  },
  computed: {
    innerHeight() {
      const height = window.innerHeight;
      return height - 100;
    },
  },
  filters: {
    commaPoint(value) {
      const number = Number(value);
      if (number == 0) {
        return "0";
      } else if (!isNaN(number)) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.truncate-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 100%;
}
</style>
